import type { IconSvgObject } from './types';

const EnteringGeoFenceIcon: IconSvgObject = [
  ["path", { d: "M12 17L12 2.99994M12 17C12.3728 17 12.6728 16.6574 13.2728 15.9722L15 13.9999M12 17C11.6272 17 11.3272 16.6574 10.7272 15.9722L9 13.9999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 15C3.7492 15.6327 3 16.4384 3 17.3158C3 19.3505 7.02944 21 12 21C16.9706 21 21 19.3505 21 17.3158C21 16.4384 20.2508 15.6327 19 15", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default EnteringGeoFenceIcon;
